/**
 * Clé alignée sur monorg-api `ORGANIZATION_TREE_FEATURE_KEY`.
 * Le catalogue et les libellés viennent de l’API.
 */
export const ORGANIZATION_TREE_FEATURE_KEY = 'organization_tree'

/**
 * Clés alignées sur `ERole` de l’API.
 * Le super-admin est `YYX_SUPER-ADMIN`.
 * La consultation est la chaîne vide, comme `ERole.CONSULTATION`.
 */
export const EXPERIMENTAL_FEATURE_ROLES = [
  { id: 'YYX_DEVELOPPEUR', label: 'Développeur' },
  { id: 'YYX_SUPER-ADMIN', label: 'Super-administrateur' },
  { id: 'YYX_ADMIN', label: 'Administrateur' },
  { id: 'YYX_MANAGER', label: 'Manager' },
  { id: '', label: 'Consultation' },
] as const

export type ExperimentalFeatureRole = (typeof EXPERIMENTAL_FEATURE_ROLES)[number]['id']

export type ExperimentalFeaturesLoadStatus = 'idle' | 'loading' | 'ready' | 'error'

/**
 * Fail closed : la feature n’est utilisable que lorsque /me a répondu et contient la clé.
 */
export function canUseExperimentalFeature(
  status: ExperimentalFeaturesLoadStatus,
  keys: readonly string[],
  key: string,
): boolean {
  if (status !== 'ready') {
    return false
  }
  return keys.includes(key)
}
